module.exports = __webpack_public_path__ + "img/est_icon.f1a429af.svg";